export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string;
  rating: number;
  image: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  type: 'movie' | 'tv';
  featured: boolean;
  region: string;
  updateStatus: string;
}

export const movies: Movie[] = [
  {
    id: 'molidao-2026',
    title: '末日倒计时',
    year: 2026,
    category: '科幻片',
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20movie%20poster%20with%20a%20massive%20countdown%20clock%20in%20the%20sky%2C%20dramatic%20orange%20and%20red%20atmosphere%2C%20silhouettes%20of%20people%20running%20through%20a%20destroyed%20city%2C%20cinematic%20lighting%20with%20lens%20flare%2C%20dark%20moody%20tone%2C%20minimalist%20poster%20design%20with%20Chinese%20film%20aesthetic&width=600&height=800&seq=movie-molidao&orientation=portrait',
    description: '在不远的未来，一颗巨大的小行星正朝地球飞来。一群科学家必须在72小时内找到拯救人类的方法。面对时间的紧迫和人性的考验，他们将如何抉择？这是一部关于勇气、牺牲和希望的史诗级科幻巨制。',
    director: '张艺谋',
    cast: ['吴京', '刘德华', '赵丽颖', '易烊千玺'],
    duration: '148分钟',
    type: 'movie',
    featured: true,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'nihao-shijie-2026',
    title: '你好，世界',
    year: 2026,
    category: '爱情片',
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20movie%20poster%20featuring%20a%20couple%20walking%20through%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20minimalist%20design%20with%20gentle%20pink%20and%20cream%20tones%2C%20cinematic%20romance%20aesthetic&width=600&height=800&seq=movie-nihao&orientation=portrait',
    description: '两个来自不同世界的年轻人，在一次偶然的相遇中擦出火花。他们用最纯粹的方式向彼此说"你好"，用最深情的方式守护这份来之不易的爱情。跨越文化、语言和距离，这是一个关于爱与勇气的温暖故事。',
    director: '陈可辛',
    cast: ['周冬雨', '王一博', '刘昊然'],
    duration: '126分钟',
    type: 'movie',
    featured: true,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'wuxia-fengyun-2026',
    title: '武侠风云录',
    year: 2026,
    category: '动作片',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20movie%20poster%20with%20a%20warrior%20in%20traditional%20Chinese%20robes%20standing%20on%20a%20mountain%20peak%20at%20dawn%2C%20misty%20atmosphere%2C%20dramatic%20golden%20sunrise%20lighting%2C%20epic%20cinematic%20composition%2C%20warm%20earthy%20tones&width=600&height=800&seq=movie-wuxia&orientation=portrait',
    description: '江湖风云再起，一位隐退多年的武林高手被迫重出江湖。在寻找失散多年的女儿途中，他卷入了朝廷、江湖和神秘组织的三方角力。刀光剑影中，他能否守护自己的信念和亲人？',
    director: '徐克',
    cast: ['甄子丹', '杨紫琼', '张震', '章子怡'],
    duration: '155分钟',
    type: 'movie',
    featured: true,
    region: '中国香港',
    updateStatus: '已完结',
  },
  {
    id: 'xingji-tanxian-2026',
    title: '星际探险家',
    year: 2026,
    category: '科幻片',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=A%20space%20exploration%20movie%20poster%20showing%20astronauts%20floating%20near%20a%20massive%20alien%20spaceship%2C%20deep%20space%20background%20with%20colorful%20nebula%2C%20cinematic%20sci-fi%20aesthetic%2C%20dark%20and%20mysterious%20tone&width=600&height=800&seq=movie-xingji&orientation=portrait',
    description: '公元2150年，人类首次发现外星文明信号。一支由各国精英组成的探险队踏上了前往未知星系的旅程。在浩瀚宇宙中，他们将面对无法想象的危险和震撼心灵的发现。',
    director: '郭帆',
    cast: ['沈腾', '黄渤', '刘亦菲'],
    duration: '142分钟',
    type: 'movie',
    featured: false,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'xiaoao-jianghu-2026',
    title: '笑傲江湖',
    year: 2026,
    category: '电视剧',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20TV%20series%20poster%20featuring%20multiple%20characters%20in%20flowing%20traditional%20costumes%20with%20swords%2C%20dramatic%20mountain%20landscape%20background%2C%20warm%20golden%20and%20green%20tones%2C%20epic%20wuxia%20aesthetic&width=600&height=800&seq=movie-xiaoao&orientation=portrait',
    description: '经典武侠名著改编，讲述了令狐冲在江湖中的传奇经历。从华山派弟子到一代大侠，他经历了爱恨情仇、门派纷争，最终领悟了真正的侠义之道。全剧共58集，画面精美，打斗场面震撼。',
    director: '李国立',
    cast: ['肖战', '迪丽热巴', '王凯', '李沁'],
    duration: '58集',
    type: 'tv',
    featured: true,
    region: '中国大陆',
    updateStatus: '更新至42集',
  },
  {
    id: 'kongbu-yiyuan-2026',
    title: '恐怖医院',
    year: 2026,
    category: '恐怖片',
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=A%20horror%20movie%20poster%20showing%20an%20abandoned%20hospital%20corridor%20with%20flickering%20lights%2C%20dark%20shadows%2C%20eerie%20greenish%20atmosphere%2C%20a%20mysterious%20figure%20in%20the%20distance%2C%20cinematic%20horror%20aesthetic&width=600&height=800&seq=movie-kongbu&orientation=portrait',
    description: '一群医学院的学生在一座废弃多年的精神病院进行探险直播。随着夜幕降临，诡异的事件接连发生。他们发现这座医院隐藏着一个可怕的秘密，而他们正在一步步走入陷阱。',
    director: '温子仁',
    cast: ['张子枫', '彭昱畅', '文淇'],
    duration: '108分钟',
    type: 'movie',
    featured: false,
    region: '中国台湾',
    updateStatus: '已完结',
  },
  {
    id: 'dongwu-cheng-2026',
    title: '动物城2',
    year: 2026,
    category: '动画片',
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20animated%20movie%20poster%20with%20various%20cute%20animal%20characters%20in%20a%20modern%20city%20setting%2C%20bright%20and%20cheerful%20color%20palette%2C%20playful%20design%2C%20family-friendly%20animation%20aesthetic&width=600&height=800&seq=movie-dongwu&orientation=portrait',
    description: '动物城的居民们迎来了全新的挑战！当一位神秘的发明家来到城市，带来了改变动物世界的新科技。兔子朱迪和狐狸尼克再次联手，揭开了一场阴谋，守护他们热爱的家园。',
    director: '饺子',
    cast: ['杨幂（配音）', '雷佳音（配音）', '黄磊（配音）'],
    duration: '118分钟',
    type: 'movie',
    featured: true,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'dushi-qingyuan-2026',
    title: '都市情缘',
    year: 2026,
    category: '电视剧',
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20romance%20TV%20drama%20poster%20showing%20young%20professionals%20in%20a%20city%20skyline%20setting%2C%20warm%20evening%20lighting%2C%20stylish%20contemporary%20aesthetic%2C%20soft%20romantic%20atmosphere&width=600&height=800&seq=movie-dushi&orientation=portrait',
    description: '在上海这座繁华都市中，四位来自不同背景的年轻人因为工作、生活和爱情交织在一起。他们追逐梦想，经历挫折，收获成长。这是一部关于当代都市青年生活的暖心剧集。',
    director: '赵薇',
    cast: ['杨紫', '李现', '关晓彤', '白敬亭'],
    duration: '36集',
    type: 'tv',
    featured: false,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'xiju-rensheng-2026',
    title: '喜剧人生',
    year: 2026,
    category: '喜剧片',
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20comedy%20movie%20poster%20with%20a%20group%20of%20friends%20laughing%20together%20in%20a%20colorful%20urban%20setting%2C%20bright%20vibrant%20colors%2C%20energetic%20and%20fun%20atmosphere%2C%20warm%20lighting&width=600&height=800&seq=movie-xiju&orientation=portrait',
    description: '一个失意的喜剧演员在人生最低谷时，意外获得了一个改变命运的机会。他组建了一支"废柴团队"，用笑声治愈自己，也温暖他人。这是一部让你笑中带泪的暖心喜剧。',
    director: '宁浩',
    cast: ['徐峥', '黄渤', '王宝强', '马丽'],
    duration: '132分钟',
    type: 'movie',
    featured: false,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'jilupian-diqiu-2026',
    title: '地球脉动：中国篇',
    year: 2026,
    category: '纪录片',
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=A%20nature%20documentary%20poster%20showcasing%20diverse%20Chinese%20landscapes%20from%20snow%20mountains%20to%20tropical%20forests%20to%20deserts%2C%20wildlife%20animals%20including%20pandas%20and%20snow%20leopards%2C%20breathtaking%20cinematography%2C%20warm%20natural%20tones&width=600&height=800&seq=movie-jilupian&orientation=portrait',
    description: '历时五年拍摄，跨越中国全境，记录下最震撼人心的自然奇观。从青藏高原到南海珊瑚礁，从东北森林到西南雨林，展现中国大地上丰富多彩的生命奇迹。',
    director: '陆川',
    cast: ['陈坤（旁白）'],
    duration: '6集',
    type: 'tv',
    featured: true,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'xuanyi-dashi-2026',
    title: '悬疑大师',
    year: 2026,
    category: '悬疑片',
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20movie%20poster%20with%20a%20detective%20silhouette%20standing%20in%20rain%20under%20a%20streetlamp%2C%20dark%20noir%20atmosphere%2C%20smoky%20urban%20alley%2C%20dramatic%20shadows%2C%20tense%20cinematic%20aesthetic&width=600&height=800&seq=movie-xuanyi&orientation=portrait',
    description: '一位退休的刑侦专家被邀请调查一起离奇的连环案件。每个犯罪现场都留下了精心设计的谜题。随着调查深入，他发现案件背后隐藏着一个惊天阴谋，而这个阴谋与他二十年前的一桩旧案密切相关。',
    director: '曹保平',
    cast: ['段奕宏', '邓超', '谭卓'],
    duration: '138分钟',
    type: 'movie',
    featured: false,
    region: '中国大陆',
    updateStatus: '已完结',
  },
  {
    id: 'guzhuang-chuanqi-2026',
    title: '古装传奇',
    year: 2026,
    category: '电视剧',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20drama%20poster%20with%20elegant%20royal%20characters%20in%20elaborate%20traditional%20costumes%2C%20palace%20background%20with%20golden%20decorations%2C%20rich%20warm%20colors%2C%20luxurious%20imperial%20aesthetic&width=600&height=800&seq=movie-guzhuang&orientation=portrait',
    description: '大唐盛世，一位出身寒门的少女凭借才华和勇气步入宫廷。在权力的漩涡中，她守护初心，书写了一段跌宕起伏的传奇人生。精美的服化道和宏大的场景，带你穿越千年感受大唐风华。',
    director: '郑晓龙',
    cast: ['赵丽颖', '陈晓', '刘诗诗', '胡歌'],
    duration: '48集',
    type: 'tv',
    featured: true,
    region: '中国大陆',
    updateStatus: '更新至30集',
  },
];

export const getFeaturedMovies = (): Movie[] => {
  return movies.filter((m) => m.featured);
};

export const getMoviesByCategory = (category: string): Movie[] => {
  if (category === '全部') return movies;
  return movies.filter((m) => m.category === category);
};

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getRelatedMovies = (id: string, limit: number = 4): Movie[] => {
  const movie = getMovieById(id);
  if (!movie) return [];
  return movies
    .filter((m) => m.id !== id && m.category === movie.category)
    .slice(0, limit);
};